export default __webpack_public_path__ + "static/SRC BS001 - Product Specifications & Technical Data-603d4ef4a6524540113edd43f4f48832.pdf";